// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"443":"graphic-patterns","636":"samples","684":"tech-specs","935":"image-gallery"}[chunkId] + "." + {"443":"7812fb72ec275373","636":"f4607c6f414c6212","684":"5e22bb58205fbf3c","935":"8ad7423e157f82b8"}[chunkId] + ".js";
};